import React from 'react'

const path1 = `M25.5333 17C20.8187 17 17 20.8187 17 25.5333V102.333C17 107.048 20.8187 110.867 25.5333 110.867H102.333C107.048 110.867 110.867 107.048 110.867 102.333V25.5333C110.867 20.8187 107.048 17 102.333 17H25.5333ZM51.1333 29.8H76.7333C81.448 29.8 85.2667 33.6187 85.2667 38.3333V89.5333C85.2667 94.248 81.448 98.0667 76.7333 98.0667H51.1333C46.4187 98.0667 42.6 94.248 42.6 89.5333V38.3333C42.6 33.6187 46.4187 29.8 51.1333 29.8Z`
const path2 = `M51.25 41C51.25 39.6193 52.3693 38.5 53.75 38.5H74.25C75.6307 38.5 76.75 39.6193 76.75 41V61.5C76.75 62.8807 75.6307 64 74.25 64H53.75C52.3693 64 51.25 62.8807 51.25 61.5V41Z`

const SwitchOnIcon = ({ size, color }: { size: number; color: string }) => (
  <svg width={size} height={size} viewBox='0 0 128 128' fill='none'>
    <path d={path1} fill={color} />
    <path d={path2} fill={color} />
  </svg>
)

export default SwitchOnIcon
